import { Injectable } from '@angular/core';
import { NavigationLoaderService } from '../core/navigation/navigation-loader.service';
import { IamService } from './iam.service';
import { getAsignacionesActorEmployeeId } from '../modules/asignaciones/utils/asignaciones-actor.util';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

/**
 * Tras Keycloak, carga el árbol de menús efectivo del empleado
 * y actualiza el sidenav (sin fallback al menú hardcodeado completo).
 */
@Injectable({
  providedIn: 'root',
})
export class MenuSessionService {
  private syncPromise: Promise<void> | null = null;
  private readonly baseUrl = environment.administrativoBaseUrl;

  constructor(
    private readonly iamService: IamService,
    private readonly navigationLoader: NavigationLoaderService,
    private readonly http: HttpClient,
  ) {}

  syncMenuFromSession(): Promise<void> {
    if (this.syncPromise) {
      return this.syncPromise;
    }

    this.syncPromise = this.doSync().finally(() => {
      this.syncPromise = null;
    });
    return this.syncPromise;
  }

  private async doSync(): Promise<void> {
    try {
      let tree = await this.iamService.getMyMenuTree();

      if (!tree?.menuArbol) {
        const employeeId = await this.resolveEmployeeIdFallback();
        if (employeeId) {
          tree = await this.iamService.getEmployeeMenuTree(employeeId);
        }
      }

      const menuArbol = tree?.menuArbol ?? [];
      localStorage.setItem('menuArbol', JSON.stringify(menuArbol));
      if (tree?.employee?.id) {
        localStorage.setItem('sessionId', String(tree.employee.id));
        localStorage.setItem('employeeId', String(tree.employee.id));
      }
      this.navigationLoader.loadNavigation();
    } catch (error) {
      console.error('Error syncing menu session', error);
      localStorage.setItem('menuArbol', JSON.stringify([]));
      this.navigationLoader.loadNavigation();
    }
  }

  private async resolveEmployeeIdFallback(): Promise<number | undefined> {
    const fromActor = getAsignacionesActorEmployeeId();
    if (fromActor) return fromActor;

    try {
      const response = await this.http
        .get<{ ok?: boolean; data?: { id?: number } }>(`${this.baseUrl}/employees/me`)
        .toPromise();
      const id = response?.data?.id;
      if (id != null && Number(id) > 0) {
        localStorage.setItem('employeeId', String(id));
        localStorage.setItem('sessionId', String(id));
        return Number(id);
      }
    } catch (error) {
      console.error('Fallback /employees/me failed', error);
    }
    return undefined;
  }
}
